import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import RabbitMqApiService from "@/core/services/api.service.rabbitmq";

export default {
  name: "rabbitmq-monitoring",
  data() {
    return {
      loading: false,
      summary: null,
      search: "",
      trackedHeaders: [
        { text: "Workflow", value: "label", sortable: true },
        { text: "Group", value: "group", sortable: true, width: "140px" },
        { text: "Status", value: "status", sortable: true, width: "140px" },
        { text: "Ready", value: "readyMessages", sortable: true, width: "100px" },
        { text: "Unacked", value: "unackedMessages", sortable: true, width: "100px" },
        { text: "Total", value: "totalMessages", sortable: true, width: "100px" },
        { text: "Consumers", value: "consumers", sortable: true, width: "110px" },
        { text: "Queues", value: "queueNames", sortable: false }
      ],
      queueHeaders: [
        { text: "Queue", value: "name", sortable: true },
        { text: "Status", value: "status", sortable: true, width: "140px" },
        { text: "State", value: "state", sortable: true, width: "120px" },
        { text: "Ready", value: "readyMessages", sortable: true, width: "100px" },
        { text: "Unacked", value: "unackedMessages", sortable: true, width: "100px" },
        { text: "Total", value: "totalMessages", sortable: true, width: "100px" },
        { text: "Consumers", value: "consumers", sortable: true, width: "110px" }
      ]
    };
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Monitoring" }, { title: "RabbitMQ" }]);
    RabbitMqApiService.init();
    await this.fetchSummary();
  },
  computed: {
    trackedItems() {
      const workflows = this.summary?.trackedWorkflows || [];
      return workflows
        .map((workflow) => ({
          ...workflow,
          queueNames: (workflow.queues || []).map((queue) => queue.name).join(", ")
        }))
        .filter((workflow) => this.matchesSearch([workflow.label, workflow.group, workflow.status, workflow.queueNames]));
    },
    otherQueueItems() {
      const queues = this.summary?.unmappedPreview || [];
      return queues.filter((queue) =>
        this.matchesSearch([queue.name, queue.status, queue.state, String(queue.readyMessages)])
      );
    },
    generatedAtText() {
      if (!this.summary?.generatedAt) {
        return "-";
      }
      const generatedAt = new Date(this.summary.generatedAt);
      return generatedAt.toLocaleString();
    }
  },
  methods: {
    async fetchSummary() {
      this.loading = true;
      try {
        const response = await RabbitMqApiService.getSummary();
        this.summary = response.data;
      } catch (error) {
        console.error("Error loading RabbitMQ summary:", error);
        const message = error?.response?.data?.message || "Failed to load RabbitMQ summary";
        this.showToast(message, "danger");
      } finally {
        this.loading = false;
      }
    },
    matchesSearch(values) {
      if (!this.search) {
        return true;
      }
      const query = this.search.trim().toLowerCase();
      return values.some((value) => (value || "").toString().toLowerCase().includes(query));
    },
    getStatusColor(status) {
      const colors = {
        ACTIVE: "blue",
        IDLE: "grey",
        NO_CONSUMER: "red",
        DELAYED: "orange",
        STUCK: "deep-orange",
        FAILING: "red darken-1"
      };
      return colors[status] || "grey darken-1";
    },
    formatNumber(value) {
      return new Intl.NumberFormat().format(value || 0);
    },
    showToast(message, variant) {
      this.$bvToast?.toast(message, {
        variant,
        solid: true,
        autoHideDelay: 4000
      });
    }
  }
};
